import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const animalsAProtocol: ImportTypeConfig = {
  protocolField: {
    labelKey: 'protocol',
    name: 'protocol_schedule',
  },
  type: 'animals_a_protocol',
}
